export const formatPeriods = (periods: string[]): string[] => {
  return periods.map((period: string): string => {
    return formatPeriod(period);
  });
};

export const formatPeriod = (period: string): string => {
    const [start, end] = period.split("-");
    return start + "-07-01–" + end + "-06-30";
};

export const formatId = (id: string): string => {
    return [id.slice(0, -4), "-", id.slice(-4)].join('');
};

export const formatDatum = (datum: string): string => {
  return [datum.slice(0, 10), " kl. ", datum.slice(11, 16)].join('');
};

export const separeraTecken = (text: string, separator: string): string => {
	return text.split('').join(separator);
}